export const megabytesToBytes = (mb: number) => mb * 1024 * 1024;
export const bytesToKiloBytes = (bytes: number) => bytes / 1024;
